import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';
import { useUnsafeTranslation } from '../../../../i18next';
import { getHeatmapColor } from '../ReportExperienceCompletionHeatmap/colors';

// NOTE that Data should be the following format:
// Within data we need two values, one that is the number of tasks not completed and second the number of tasks completed following e.g
// const dataCheck = [
//   { name: 'Total Not Completed', value: 135 },
//   { name: 'Total Completed', value: 1536 }
// ];

const TooltipContainer = styled('div')`
  background-color: white;
  padding: 10px;
  border: lightgray solid 1px;
  min-width: 200px;
`;

const circleSize = 70;
export const TasksPieChart = ({
  data
}: {
  data: {
    name: string;
    value: number;
  }[];
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <PieChart width={circleSize} height={circleSize}>
      {data && (
        <text
          x={36}
          y={36}
          textAnchor="middle"
          dominantBaseline="middle"
          fontVariant="tabular-nums"
        >
          {Math.round(
            (data[1].value / (data[1].value + data[0].value)) * 100 || 0
          )}
          %
        </text>
      )}
      <Pie
        data={data}
        dataKey="value"
        innerRadius="80%"
        outerRadius="100%"
        fill={
          getHeatmapColor(data[1].value / (data[1].value + data[0].value) || 0)
            .background
        }
        startAngle={-270}
        endAngle={90}
        paddingAngle={0}
        blendStroke
      >
        <Cell key="test" fill="#e5e5e5" />
      </Pie>
      <Tooltip
        position={{ x: 0, y: -70 }}
        content={
          <TooltipContainer>
            <Typography variant="body2">
              {t('Completion rate of tasks past their deadline')}
            </Typography>
          </TooltipContainer>
        }
      />
    </PieChart>
  );
};
